import { render, staticRenderFns } from "./GlobalBlockDialog.vue?vue&type=template&id=36e6cf98&"
import script from "./GlobalBlockDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalBlockDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports